import { z } from 'zod'

export const armaFormSchema = z.object({
  idatirador: z.number({ required_error: 'Atirador obrigatorio' }).int().positive('Atirador obrigatorio'),
  marca: z.string().min(1, 'Marca obrigatoria').max(80),
  modelo: z.string().min(1, 'Modelo obrigatorio').max(120),
  calibre: z.string().min(1, 'Calibre obrigatorio').max(40),
  tipo: z.string().min(1, 'Tipo obrigatorio').max(50),
})

export type ArmaFormData = z.infer<typeof armaFormSchema>
